<template lang='pug'>
  v-container.px-3.profile-container(fluid)
    v-btn(v-if="itemMobile === '' && isMobile" dark="" small text @click="$router.go(-1)").fixed-back-button
      v-icon(size="25") mdi-chevron-left
    //- Dialog
    v-dialog( :fullscreen='isMobile' v-if="updateItemDialog" persistent :value='updateItemDialog'  max-width='800px'   transition="dialog-bottom-transition")
      update-item(:model ='profile' @close="updateItemDialog=false")
    //- Desktop
    v-row.mx-auto(style="contain: content;")
      v-col(cols="12" xs="12" sm="12" md="4")
        v-card.my-3.rounded-lg.py-3(height="450")
          //- Update buttons
          v-btn(text small color='green' absolute right="0" @click.stop ='updateItemDialog=true')
            v-icon mdi-pen
          v-img.rounded-circle.mx-auto(:src="profile.image ? profile.image:userImage" height="150" width="150")
          h3.text-center {{profile.name}} {{profile.last_name}}
          v-list.mt-2(dense="")
            v-list-item-group(v-model="item" color="primary")
              v-list-item(v-for="(item, i) in items" :key="i")
                v-list-item-avatar
                  v-icon(v-text="item.icon")
                v-list-item-content
                  v-list-item-title(v-text="item.title")
                v-list-item-action
                  v-btn(icon text)
                    v-icon mdi-chevron-right
              // Cerrar sesion
              v-list-item(@click="logout")
                v-list-item-avatar
                  v-icon(v-text="'mdi-close'")
                v-list-item-content
                  v-list-item-title(v-text="$t('user_profile.logout')")
                v-list-item-action
                  v-btn(icon text)
                    v-icon mdi-chevron-right
      v-col(cols="12" xs="12" sm="12" md="8")
        v-card.my-3.rounded-lg.py-3(height="450")
          .card-text-details
            .pa-3(v-if="item === 0 || !item")
              v-row
                v-col(cols="12")
                  h3 {{items[item].title}}
                  v-spacer
                  v-checkbox.ma-0( v-model="profile.showNotifSnack" @click="changeShowNotifSnack()" label="Ver aviso de la ultima notificación")
                v-col(cols="12" md="6")
                  v-text-field(:label="$t('user_profile.detail_form.name')" disabled="" v-model="profile.name")
                v-col(cols="12" md="6")
                  v-text-field.purple-input(:label="$t('user_profile.detail_form.last_name')" disabled="" v-model="profile.last_name")
                v-col(cols="12" md="6")
                  v-text-field.purple-input(:label="$t('user_profile.detail_form.email')" disabled="" v-model="profile.notification_email")
                v-col(cols="12" md="6")
                  v-text-field.purple-input(:label="$t('user_profile.detail_form.phone')" disabled="" v-model="profile.phone")
              v-row(v-if="profile.direction")
                v-col(cols="12")
                  h3 {{$t('user_profile.menu.my_address')}}
                v-col(cols="12" md="6")
                  v-text-field(:label="$t('user_profile.direction.address')" disabled="" v-model="profile.direction.address")
                v-col(cols="12" md="6")
                  v-text-field.purple-input(:label="$t('user_profile.direction.city')" disabled="" v-model="profile.direction.city")
                v-col(cols="12" md="6")
                  v-text-field.purple-input(:label="$t('user_profile.direction.state')" disabled="" v-model="profile.direction.state")
                v-col(cols="12" md="6")
                  v-text-field.purple-input(:label="'Pais'" disabled="" v-model="profile.direction.country")
            .pa-3(v-if="item === 1")
              v-row(v-if="banProgresBar || plan")
                v-progress-linear(v-if="banProgresBar" indeterminate='' color='teal')
                v-col(cols="12" md="6")
                  v-text-field(v-if="plan" :label="$t('user_profile.plan_form.plan')" disabled="" v-model="plan")
                v-col(cols="12" md="6")
                  v-text-field(v-if="state" :label="$t('user_profile.plan_form.state')" disabled="" v-model="state")
                v-col(cols="12" md="12")
                  p(style="color:#008E95;") {{$t('user_profile.plan_form.plans')}}
                  //- router-link(style="color:#008E95; text-decoration:none;" :to="'/dashboard/Plans'")
                template(v-if="plan !== 'Plan_Reactivate'")
                  v-col(cols="12" md="6" v-if="!banProgresBar")
                    v-text-field(:label="$t('user_profile.plan_form.start')" disabled="" v-model="periodStart")
                  v-col(cols="12" md="6" v-if="!banProgresBar")
                    v-text-field(:label="$t('user_profile.plan_form.end')" disabled="" v-model="periodEnd")
                template(v-else)
                  v-col(cols="12" md="6" v-if="!banProgresBar")
                    v-text-field(label="Limite de facturas de ventas" disabled="" v-model="restrictions.maxAmountSale")
                v-col(cols="12")
                  h4.display-2.font-weight-light.black--text
                    | {{$t('user_profile.plan_form.benefits')}}
                v-col(cols="12" md="6")
                  v-text-field(:label="$t('user_profile.plan_form.collaborators')" disabled="" v-model="restrictions.collaborators")
                v-col(cols="12" md="6")
                  v-text-field.purple-input(:label="$t('user_profile.plan_form.point_of_sale')" disabled="" v-model="restrictions.salePoints")
                v-col(cols="12" md="12")
                  v-text-field.purple-input(:label="$t('user_profile.plan_form.virtual_stores')" disabled="" v-model="restrictions.virtualShops")
                div
                  router-link(v-if="state !== 'active' && !banProgresBar" style="color:#008E95; text-decoration:none;" :to="'/dashboard/planner'") {{$t('user_profile.plan_form.go_to_pay')}}<!--Go To PAY-->
              v-row.justify-center(v-else)
                v-btn(color="primary" style="padding: 10px !important;" :loading="loading" @click="subscribeToReactivate") suscribirse al plan reactivate
    //- v-card(v-if="!isMobile")
          // Contenido
          //- v-col(cols="8")
              v-card
                  // Mis detalles
                  v-card-text(v-if="item === 0 || !item")
                      v-row
                        v-col.d-flex(cols="12")
                            h3 {{items[item].title}}
                            v-spacer
                            v-checkbox.ma-0( v-model="profile.showNotifSnack" @click="changeShowNotifSnack()" label="Ver aviso de la ultima notificación")
                        v-col(cols="12" md="6")
                            v-text-field(:label="$t('user_profile.detail_form.name')" disabled="" v-model="profile.name")
                        v-col(cols="12" md="6")
                            v-text-field.purple-input(:label="$t('user_profile.detail_form.last_name')" disabled="" v-model="profile.last_name")
                        v-col(cols="12" md="6")
                            v-text-field.purple-input(:label="$t('user_profile.detail_form.email')" disabled="" v-model="profile.notification_email")
                        v-col(cols="12" md="6")
                            v-text-field.purple-input(:label="$t('user_profile.detail_form.phone')" disabled="" v-model="profile.phone")
                      v-row(v-if="profile.direction")
                        v-col(cols="12")
                            h3 {{$t('user_profile.menu.my_address')}}
                        v-col(cols="12" md="6")
                            v-text-field(:label="$t('user_profile.direction.address')" disabled="" v-model="profile.direction.address")
                        //-
                          v-col(cols="12" md="6")
                              v-text-field.purple-input(:label="$t('user_profile.direction.street')" disabled="" v-model="profile.direction.street")
                        v-col(cols="12" md="6")
                            v-text-field.purple-input(:label="$t('user_profile.direction.city')" disabled="" v-model="profile.direction.city")
                        v-col(cols="12" md="6")
                            v-text-field.purple-input(:label="$t('user_profile.direction.state')" disabled="" v-model="profile.direction.state")
                        v-col(cols="12" md="6")
                          v-text-field.purple-input(:label="'Pais'" disabled="" v-model="profile.direction.country")
                      v-col(cols="12").text-center
                          v-btn.mr-0(color="primary" small @click.stop='updateItemDialog=true')
                              | {{$t('user_profile.detail_form.edit_profile_btn')}}
                  // Plan
                  v-card-text(v-if="item === 1")
                    v-row(v-if="banProgresBar || plan")
                      v-progress-linear(v-if="banProgresBar" indeterminate='' color='teal')
                      v-col(cols="12" md="6")
                        v-text-field(v-if="plan" :label="$t('user_profile.plan_form.plan')" disabled="" v-model="plan")
                      v-col(cols="12" md="6")
                        v-text-field(v-if="state" :label="$t('user_profile.plan_form.state')" disabled="" v-model="state")
                      v-col(cols="12" md="12")
                        p(style="color:#008E95;") {{$t('user_profile.plan_form.plans')}}
                        //- router-link(style="color:#008E95; text-decoration:none;" :to="'/dashboard/Plans'")
                      template(v-if="plan !== 'Plan_Reactivate'")
                        v-col(cols="12" md="6" v-if="!banProgresBar")
                          v-text-field(:label="$t('user_profile.plan_form.start')" disabled="" v-model="periodStart")
                        v-col(cols="12" md="6" v-if="!banProgresBar")
                          v-text-field(:label="$t('user_profile.plan_form.end')" disabled="" v-model="periodEnd")
                      template(v-else)
                        v-col(cols="12" md="6" v-if="!banProgresBar")
                          v-text-field(label="Limite de facturas de ventas" disabled="" v-model="restrictions.maxAmountSale")
                      v-col(cols="12")
                        h4.display-2.font-weight-light.black--text
                          | {{$t('user_profile.plan_form.benefits')}}
                      v-col(cols="12" md="6")
                        v-text-field(:label="$t('user_profile.plan_form.collaborators')" disabled="" v-model="restrictions.collaborators")
                      v-col(cols="12" md="6")
                        v-text-field.purple-input(:label="$t('user_profile.plan_form.point_of_sale')" disabled="" v-model="restrictions.salePoints")
                      v-col(cols="12" md="12")
                        v-text-field.purple-input(:label="$t('user_profile.plan_form.virtual_stores')" disabled="" v-model="restrictions.virtualShops")
                      div
                        router-link(v-if="state !== 'active' && !banProgresBar" style="color:#008E95; text-decoration:none;" :to="'/dashboard/planner'") {{$t('user_profile.plan_form.go_to_pay')}}<!--Go To PAY-->
                    v-row.justify-center(v-else)
                      v-btn(color="primary" style="padding: 10px !important;" :loading="loading" @click="subscribeToReactivate") suscribirse al plan reactivate
                    Planner
                  // Mercadopago
                  v-card-text(v-if="item === 2")
                    h3 {{items[item].title}}
                    v-row
                      v-col(cols="12" ).text-center
                        div(v-if="!profile.mp")
                          p.text-justify.my-2 Si deseas agregar Mercado Pago como método de pago para tu tienda virtual debes vincular tu cuenta dando click al botón.
                          v-btn(color="primary" @click="addMP") agregar Mercadopago
                        div(v-else)
                          | Ya te encuentras afiliado a mercado pago
                          v-row.my-2
                            v-col(cols="12" md="6")
                              v-text-field(:label="$t('user_profile.mercado_pago.access')" disabled="" :value="profile.mp.access_token | transformString")
                            v-col(cols="12" md="6")
                              v-text-field.purple-input(:label="$t('user_profile.mercado_pago.date')" disabled="" :value="profile.mp.createdAt | momentMP")
</template>

<script>
  import loaders from '@/plugins/mixins/loaders'
  import UpdateItem from './UpdateProfile'
  import userImage from '@/assets/user.png'
  import { auth } from '@/plugins/auth/firebase'
  import Cookie from 'js-cookie'
  import moment from 'moment'
  export default {

    components: {
      UpdateItem: UpdateItem,
      Planner: () => import('@/views/custom/plans/Planner'),
      Avatar: () => import('@/views/marketplace/component/profile/Avatar'),
    },

    filters: {
      transformString: function (value) {
        return `${value.substr(0, 4)}xxxxxxxxxxxxxxxxx${value.substr(70, value.lenght)}`
      },
      momentMP (date) {
        return moment(date).format('MM-DD-YYYY hh:mm A')
      },
    },

    mixins: [loaders],

    data () {
      return {
        loading: false,
        userImage: userImage,
        shopsList: [],
        collaboratorsList: [],
        periodStart: '',
        periodEnd: '',
        banProgresBar: true,
        plan: '',
        state: '',
        model: {},
        updateItemDialog: false,
        restrictions: {
          collaborators: 0,
          freeVirtualShopDays: 0,
          salePoints: 0,
          virtualShops: 0,
        },
        item: 0,
        itemMobile: '',
      }
    },

    computed: {
      plan_reactivate () {
        return this.$store.state.payment.plan_reactivate
      },
      isMobile () {
        return window.innerWidth < 1024
      },
      user () {
        return this.$store.state.users.user
      },
      profile () {
        return this.$store.state.users.profile
      },
      items () {
        const itemsList = [
          { title: this.$t('user_profile.menu.details'), icon: 'mdi-account' },
          { title: this.$t('user_profile.menu.my_plan'), icon: 'mdi-wallet-giftcard' },
          // { title: 'Mercadopago', icon: 'mdi-credit-card' },
        ]
        /* if (this.$store.state.users.user.role !== 'Colaborador') {
          itemsList.push({ title: this.$t('user_profile.menu.my_payments'), icon: 'mdi-swap-horizontal-circle-outline' })
        } */
        return itemsList
      },
    },

    created () {
      const vm = this
      vm.banProgresBar = true
      vm.loadProfile()
      vm.shopsList = vm.$store.getters['shops/getItems']
      vm.getDataSubscription()
      if (vm.profile.direction && !vm.profile.direction.country) {
        vm.profile.direction.country = 'Colombia'
      }
    },

    methods: {
      addMP () {
        const vm = this
        // console.log('aja')
        window.open(`https://auth.mercadopago.com.co/authorization?client_id=5925760301689146&response_type=code&platform_id=mp&state=id=${vm.user.uid}&redirect_uri=https://us-central1-tender-8006e.cloudfunctions.net/getCodeMercadoPago/`, '_blank')
      },
      changeShowNotifSnack () {
        const vm = this
        vm.$store.dispatch('users/updateProfile', vm.profile)
      },
      getDataSubscription () {
        const vm = this
        vm.$store.dispatch('users/getCollaborators').then(res => {
          vm.collaboratorsList = res
          const data = {
            shops: vm.shopsList,
            collaborators: vm.collaboratorsList,
          }
          vm.$store.dispatch('payment/getSubscriptionData', data).then(res => {
            vm.banProgresBar = false
            if (res && res.status) {
              vm.plan = res.data.idClient
              vm.restrictions = res.restrictions
              vm.state = res.status.val
              vm.periodStart = res.data.createdAt.substring(0, 10)
              if (res.data.interval === 'month') {
                vm.periodEnd = moment(res.data.createdAt).add(30, 'days').format('YYYY-MM-DD')
              } else if (res.data.interval === 'year') {
                vm.periodEnd = moment(res.data.createdAt).add(1, 'year').format('YYYY-MM-DD')
              } else if (res.data.idClient === 'PERSONALIZADO') {
                vm.periodEnd = moment(res.restrictions.dateUntil).format('YYYY-MM-DD')
              }
            }
          }).catch(error => {
            console.log('errooooooooooor', error)
          })
        })
      },
      subscribeToReactivate () {
        const vm = this
        vm.loading = true
        const dataSubscription = {
          id_plan: vm.plan_reactivate.data.id_plan,
          restrictions: vm.plan_reactivate.data.restrictions,
          shops: vm.shopsList,
          collaborators: [],
        }
        vm.$store.dispatch('payment/createSubscription', dataSubscription).then(() => {
          // subscripcion creada
          const dataRestrictions = {
            uid: vm.$store.state.users.user.uid,
            restrictions: vm.plan_reactivate.data.restrictions,
          }
          vm.$store.dispatch('users/saveRestrictions', dataRestrictions).then((res) => {
            vm.loading = false
            vm.getDataSubscription()
          })
        })
      },
      async logout () {
        const vm = this
        // console.log('logout')
        await auth.signOut()
        await Cookie.remove('access_token')
        vm.$store.dispatch('users/clearUser').then(function () {
          vm.$router.push('/').catch(err => {
            console.log(err)
          })
        })
      },
    },
  }
</script>
<style lang="scss">
  .profile-container{
    display: flex;
    flex-direction: column-reverse;
    @media (min-width : 600px){
      flex-direction: row;
      flex-wrap: nowrap;
    }
    .card-text-details{
      height: 100%;
      overflow-y: scroll !important;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
</style>
